// Экран конверта — клик по конверту запускает 3D-открытие, затем показывает письмо.
// data-opening → проигрывается CSS-анимация (печать/клапан/письмо).
// data-opened  → показываем экран приглашения (Wedding.styl), конверт скрывается.
const root = document.documentElement;

const OPEN_ANIM_MS = 2700; // письмо оседает к ~2.8с (задержка 1.3 + анимация 1.5) — показываем приглашение к концу

export function initEnvelope() {
	document.addEventListener("click", (event) => {
		if (!event.target.closest("[data-open]")) return;
		if (root.hasAttribute("data-opening")) return; // уже открываем — игнор повторных кликов

		root.setAttribute("data-opening", "");

		// Разблокируем аудио жестом пользователя, но пока БЕЗ звука (muted) —
		// iOS разрешает muted-автоплей. Реальный звук включим на показе экрана.
		const audio = document.getElementById("bg-audio");
		if (audio) {
			audio.muted = true;
			audio.play().catch(() => {}); // вдруг браузер заблокирует — не падаем
		}

		// после анимации открытия — показать письмо и включить музыку с начала
		setTimeout(() => {
			root.setAttribute("data-opened", "");
			window.scrollTo(0, 0);

			if (audio) {
				audio.currentTime = 0;
				audio.muted = false; // снятие mute у уже играющего элемента автоплей не блокирует
				audio.play().catch(() => {});
			}
		}, OPEN_ANIM_MS);
	});
}
